import axios, { AxiosResponse } from 'axios';
import baseAPI from '@/api/base';
import store from '@/store';
import { EndSupportSession, StartSupportSession } from '@/dtos/support_session.dto';
import { SUPPORT_SESSION_URL } from '@/utils/urls';

// A launch the API refuses (the organization is disabled, or doesn't have the
// app) comes back as an answer for the dialog to show, not as a toast.
const ANSWER_STATUSES = [404, 409];
const acceptAnswers = (status: number) =>
  (status >= 200 && status < 300) || ANSWER_STATUSES.includes(status);

class SupportSession {
  static start = async (payload: StartSupportSession): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(SUPPORT_SESSION_URL, payload, {
      validateStatus: acceptAnswers,
    });
    return response;
  };

  // Whether a session kept across a reload is still open.
  static get = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(`${SUPPORT_SESSION_URL}/${id}`, {
      validateStatus: acceptAnswers,
    });
    return response;
  };

  // Sent outside baseAPI's handlers: it also runs while signing out, and must
  // never toast, redirect or sign out again — and with a short timeout, so
  // closing the desktop never waits long on it. Null when it couldn't be sent.
  static end = async (payload: EndSupportSession): Promise<AxiosResponse | null> => {
    const token = store.getters.sessionToken;
    if (!token) return null;
    try {
      return await axios.post(
        `${SUPPORT_SESSION_URL}/${payload.id}/end`,
        { reason: payload.reason || 'ended' },
        {
          baseURL: baseAPI.defaults.baseURL,
          headers: { Authorization: `Bearer ${token}` },
          timeout: 5000,
          validateStatus: () => true,
        }
      );
    } catch (error) {
      return null;
    }
  };
}

export default SupportSession;
